import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AiMatchCheckDialogModel } from './model/ai-match-check-dialog.model';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { LocalizableComponent } from 'src/app/shared/localization/localizable.component';

@Component({
  selector: 'broker-ai-match-check-dialog',
  templateUrl: './ai-match-check-dialog.component.html'
})
export class AiMatchCheckDialogComponent extends LocalizableComponent {
  @Output() cancelEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    @Inject(L10N_LOCALE) locale: L10nLocale,
    @Inject(MAT_DIALOG_DATA) public data: AiMatchCheckDialogModel,
  ) {
    super(locale);
  }

  close(): void {
    this.cancelEvent.emit();
  }
}
